import { gtmId, Locale, sharingArticleId } from '@/domain'
import { useEnv } from '@/lib/env'
import { parseHostname } from '@/lib/parseHostname'
import { breakpoints as bp, color, Container, Logo, Space } from '@/materials'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { PureMasthead as Masthead } from '@ta-interaktiv/react-masthead'
import { Tracking } from '@ta-interaktiv/react-tracking'
import setFavicon from 'favicon-setter'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { commonDescriptors } from '../locale/messages'
import { PopularVotePageTabs } from './popular-vote-page-tabs/popular-vote-page-tabs'
interface Props {
  popularVoteId: string
  activeTab: 'federal' | 'cantonal'
}

export const PageHeader = React.memo(({ popularVoteId, activeTab }: Props) => {
  const { intl } = useEnv()
  const parsedHostname = parseHostname()
  const [isInApp, setIsInApp] = React.useState(false)

  /*
   * This header is no longer compatible with both app variants, it only works
   * with the ballot dashboard!
   */
  const appVariant = 'ballot'

  React.useEffect(() => {
    setFavicon(`https://www.${parsedHostname.publicationDomain}/favicon.ico`)
    const weAreInApp = new URLSearchParams(window.location.search).get('appwebview') !== null
    setIsInApp(weAreInApp)
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (/iphone|ipod|ipad/.test(userAgent)) {
      // iOS
      if (!/safari/.test(userAgent)) {
        // iOS webView
        setIsInApp(true)
      }
    } else {
      if (userAgent.includes('wv')) {
        // Android webView
        setIsInApp(true)
      }
    }
  }, [setIsInApp, parsedHostname.publicationDomain])

  const homeURL = `https://www.${parsedHostname.publicationDomain}`

  const trackers = (
    <>
      {/* <TamediaPaywall
        isEnabled={true}
        paywallContainerId={'paywall_container'}
        paywallConfiguration={{
          cms_id: +sharingArticleId[appVariant]![intl.locale.split('-')[0] as Locale],
          doc_type: 'premium',
          main_channel: 'schweiz',
          sub_channel: 'schweiz',
        }}
      /> */}
      <Masthead
        mediaName={parsedHostname.publicationName}
        homepage={parsedHostname.publicationDomain}
        fullMediaName={parsedHostname.publicationName}
        hashtags={['TAGrafik', 'DDJ']}
        clickHandler={() => {}}
      />
      <Tracking articleId={sharingArticleId[appVariant]![intl.locale.split('-')[0] as Locale]} gtmId={gtmId} />
    </>
  )

  // if (/app-/i.test(window.navigator.userAgent)) {
  //   return trackers
  // } else {
  return (
    <div>
      <Container>
        {!isInApp && (
          <Root>
            <MobileLink href={homeURL} target={'_top'}>
              <Space pv2>
                <Logo />
              </Space>
            </MobileLink>
            <DesktopLink href={homeURL} target={'_top'}>
              <Logo />
            </DesktopLink>
            <CategoryTitle>
              <FormattedMessage {...commonDescriptors.back} />
            </CategoryTitle>
            {trackers}
          </Root>
        )}
        <PopularVotePageTabs popularVoteId={popularVoteId} activeTab={activeTab} isInApp={isInApp} />
      </Container>
    </div>
  )
  // }
})

const Root = styled('div')`
  label: PageHeader;
  display: flex;
  justify-content: left;
  align-items: center;
  height: 52px;
  margin-top: 12px;
  ${bp.medium`height: 60px;`};
  & .ta-masthead {
    background-color: transparent;
    position: static !important;
  }
  & .ta-masthead > .container img {
    display: none;
  }
`

const CategoryTitle = styled('div')`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-left: 30px;
`

const linkStyles = css`
  color: ${color.text};
`

const MobileLink = styled('a')`
  ${linkStyles};
  display: block;
  ${bp.medium`display: none;`};
`

const DesktopLink = styled('a')`
  ${linkStyles};
  display: none;
  ${bp.medium`display: block;`};
`
